import React from 'react';
import { Box, Container, Heading, SimpleGrid } from '@chakra-ui/react';
import { Table } from '@landsvirkjun/react.common';
import { PageHeader } from 'routes/layouts/pageHeader';
import { columns } from './ApproversOverviewTableModels';
import { ApproverSearch } from './ApproverSearch';
import { useAppSelector } from 'store';
import { approversSelector } from 'api/slices/approversSlice';

export const ApproversOverview = (): JSX.Element => {
  const { approvers = [] } = useAppSelector(approversSelector);

  return (
    <>
      <PageHeader
        left={
          <Heading as="h2" size="lg">
            Samþykkjendur ferðabeiðna
          </Heading>
        }
      />
      <Container maxW="container.lg" marginStart="ltr" pl={0}>
        <Box as="div" mt={5}>
          <SimpleGrid columns={{ base: 1, md: 2 }}>
            <ApproverSearch approversList={approvers} />
          </SimpleGrid>
        </Box>
        <Box as="div" mt={10}>
          <Table data={approvers} columns={columns} />
        </Box>
      </Container>
    </>
  );
};
